import {IHttpService, IPromise, ILogService} from 'angular';
import TSSchaden from '../../models/TSSchaden';

export default class SchadenRS {
    serviceURL: string;
    http: IHttpService;

    static $inject = ['$http', 'REST_API', '$log'];
    /* @ngInject */
    constructor($http: IHttpService, REST_API: string, private $log: ILogService) {
        this.serviceURL = REST_API + 'schaden';
        this.http = $http;
    }

    public deleteSchaden(schadenfallId: any, schadenId: any): IPromise<any> {
        return this.http.delete(this.serviceURL + '/deleteSchaden/' + encodeURIComponent(schadenfallId) + '/' + encodeURIComponent(schadenId), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    public saveSchaden(schadenfallId: any, schaden: TSSchaden): IPromise<TSSchaden> {
        let sentSchaden = {};
        sentSchaden = schaden.serialize(sentSchaden);

        this.$log.debug('sending Schaden:');
        this.$log.debug(sentSchaden);

        return this.http.post(this.serviceURL + '/saveSchaden/' + encodeURIComponent(schadenfallId), sentSchaden, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response: any) => {
            this.$log.debug('PARSING schaden REST array object', response.data);
            return new TSSchaden().deserialize(response.data);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/service/schadenRS.rest.ts